module.exports = __webpack_public_path__ + "static/img/85076D_2_3_R_20200210_LC.6881ff2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/85076D_2_3_R_20200210_LC.png
// module id = 4b8v
// module chunks = 0